'use client';

import { useEffect, useState } from 'react';
import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';

interface ImageSwiperProps {
  images: string[];
  name: string;
  uin: string;
}

const BASE_URL = 'https://images.pricedrop.co.il';

export default function ImageSwiper({ images, name, uin }: ImageSwiperProps) {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  if (images.length > 1) {
    return (
      <div className="flex min-h-[200px] w-full items-center justify-center px-10 py-2">
        <Carousel
          opts={{ loop: true, direction: 'rtl' }}
          className="relative w-full max-w-xs"
          setApi={setApi}
        >
          <CarouselContent>
            {images.map((_image) => (
              <CarouselItem key={_image} className="flex w-full items-center justify-center">
                <img
                  className="max-h-64"
                  alt={`תמונה של ${name}`}
                  src={`${BASE_URL}/${uin}/b_${_image}.webp`}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNext />
          <CarouselPrevious />
          <div className="py-2 text-center text-sm text-muted-foreground">
            {current}/{count}
          </div>
        </Carousel>
      </div>
    );
  }

  return (
    <div className="flex min-h-[200px] w-full items-center justify-center px-10 py-2">
      <img
        className="max-h-64"
        alt={`תמונה של ${name}`}
        src={`${BASE_URL}/${uin}/b_${images[0]}.webp`}
      />
    </div>
  );
}
